import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { isAuthenticatedSelector } from '../../store/auth/selectors';

/**
 * Layout route guarding everything that isn't public.
 *
 * Replaces the v5 `PrivateRoute` wrapper. Same behaviour: while we don't yet
 * know whether the user is authenticated, render nothing rather than bouncing
 * them to the login screen, and hand the requested location along in
 * `state.from` so they land where they were headed once logged in.
 */
export const RequireAuth = () => {
  const isAuthenticated = useSelector(isAuthenticatedSelector);
  const location = useLocation();

  // `null` means "not determined yet" — not "logged out".
  if (isAuthenticated === null) return null;

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <Outlet />;
};
